export const brandAssessment = [
  {
    id: 1,
    name: "Brand A",
    price: 70,
    diversity: 75,
    appearance: 70,
    durability: 60,
    quality: 80,
    postSalesSupport: 65,
    marketing: 60,
    backgroundColor: "rgba(255, 99, 132, 0.2)",
    borderColor: "rgba(255, 99, 132, 1)",
  },
  {
    id: 2,
    name: "Brand B",
    price: 30,
    diversity: 35,
    appearance: 40,
    durability: 25,
    quality: 35,
    postSalesSupport: 45,
    marketing: 50,
    backgroundColor: "rgba(54, 162, 235, 0.2)",
    borderColor: "rgba(54, 162, 235, 1)",
  },
  {
    id: 1,
    name: "Brand C",
    price: 65,
    diversity: 70,
    appearance: 80,
    durability: 85,
    quality: 70,
    postSalesSupport: 75,
    marketing: 70,
    backgroundColor: "rgba(255, 206, 86, 0.2)",
    borderColor: "rgba(255, 206, 86, 1)",
  },
];

export const popularTech = [
  {
    name: "JavaScript",
    percentage: 20.15,
    backgroundColor: "rgba(255, 99, 132, 0.2)",
  },
  {
    name: "Python",
    percentage: 15.87,
  },
  {
    name: "Java",
    percentage: 11.4,
  },
  {
    name: "Go",
    percentage: 8.8,
  },
  {
    name: "TypeScript",
    percentage: 7.5,
  },
];

export const marketingBudget = [
  {
    name: "Online Advertising",
    percentage: 60,
    backgroundColor: "rgba(255, 99, 132, 0.2)",
    borderColor: "rgba(255, 99, 132, 1)",
  },
  {
    name: "SEO",
    percentage: 10,
    backgroundColor: "rgba(54, 162, 235, 0.2)",
    borderColor: "rgba(54, 162, 235, 1)",
  },
  {
    name: "Print Advertising",
    percentage: 5,
    backgroundColor: "rgba(255, 206, 86, 0.2)",
    borderColor: "rgba(255, 206, 86, 1)",
  },
  {
    name: "Social Media",
    percentage: 20,
    backgroundColor: "rgba(75, 192, 192, 0.2)",
    borderColor: "rgba(75, 192, 192, 1)",
  },
  {
    name: "Email Marketing",
    percentage: 5,
    backgroundColor: "rgba(153, 102, 255, 0.2)",
    borderColor: "rgba(153, 102, 255, 1)",
  },
];
